import React from 'react';
import { Combobox, Pane, Text } from 'evergreen-ui';
import { useGetDatasourceTypesQuery } from 'Services/api/datasourceTypesApiTS';

export function SearchingOnStationAndDatasource({ stations, datasources, station, setStation, datasource, setDatasource }) {
  const stationDatasources = React.useMemo(() => {
    const tmp = [];
    if (station) {
      station.datasourceIds.forEach((datasourceId) => {
        tmp.push(datasources[datasourceId]);
      });
    }
    return tmp;
  }, [datasources, station]);

  return (
    <Pane display="grid" gridAutoFlow="column" gridAutoColumns="max-content" justifyContent="center" alignItems="center" columnGap=".5rem">
      <Text>поиск по</Text>
      <Combobox
        items={Object.values(stations)}
        itemToString={(value) => (value ? `[${value.station.idx}] ${value.station.name}` : '')}
        value={station}
        placeholder="Выберите станцию"
        autocompleteProps={{
          popoverMinWidth: 600,
        }}
        onChange={(station) => {
          setStation(station);
          setDatasource(null);
        }}
        selectedItem={station}
      />
      {
         station && (
         <DatasourceCombobox
           datasources={stationDatasources}
           datasource={datasource}
           setDatasource={setDatasource}
         />
         )
      }
    </Pane>
  );
}

function DatasourceCombobox({ datasources, datasource, setDatasource }) {
  const { data: datasourceTypes = [], isFetching } = useGetDatasourceTypesQuery();

  const itemToString = (datasource) => {
    if (!datasource) return '';
    const datasourceType = datasourceTypes.find((dt) => datasource.datasourceTypeId === dt.id);
    return datasourceType.fullName;
  };

  return (
    <Combobox
      isLoading={isFetching}
      items={datasources}
      itemToString={itemToString}
      value={datasource}
      autocompleteProps={{
        popoverMinWidth: 500,
      }}
      placeholder="Выберите источник"
      onChange={setDatasource}
      selectedItem={datasource}
    />
  );
}
